// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rescueally {
  /* light */
  --color-grey-0: #f8f8ff;
  --color-grey-1: #f3f3fc;
  --color-grey-2: #f1f1fc;
  --color-grey-3: #eaeafa;
  /* dark */
  --color-grey-4: #333333;
  --color-grey-5: #2f2f2f;
  --color-grey-6: #222222;
  --color-grey-7: #171717;
  --color-grey-8: #111111;
}

.rescueally {
  --color-paper-1: var(--color-grey-3);
  --color-paper-2: white;
  --color-inverse: black;
  --color-paper-text: black;
  --color-inverse-text: white;
}

@media (prefers-color-scheme: dark) {
  :not(.rescueally-light).rescueally {
    --color-paper-1: var(--color-grey-5);
    --color-paper-2: var(--color-grey-6);
    --color-inverse: var(--color-grey-0);
    --color-paper-text: white;
    --color-inverse-text: black;
  }
}

.rescueally-dark.rescueally {
    --color-paper-1: var(--color-grey-5);
    --color-paper-2: var(--color-grey-6);
    --color-inverse: var(--color-grey-0);
    --color-paper-text: white;
    --color-inverse-text: black;
  }

.rescueally {
  --color-blue-0: #48dbfb;
  --color-blue-1: #0984e3;
  --color-blue-2: #1e3799;
  --color-blue-3: #023047;
  --color-blue-4: #011a24;
  --color-red-0: #ff0000;
  --color-red-1: #ee3031;
  --color-red-2: #b33939;
  --color-red-3: #a20025;
  --color-yellow-1: #fbc531;
  --color-yellow-2: #f6b93b;
  --color-green-1: #27ae60;
  --color-green-2: #364541;
  --color-purple-0: #a55eea;
  --color-purple-1: #8e44ad;
  --color-purple-2: #5f27cd;
  --color-pink-1: #ff9ff3;

  --gradient-blue-1: radial-gradient(
    circle at 90% 100%,
    var(--color-blue-1),
    var(--color-blue-0) 250%
  );
  --gradient-purple-1: radial-gradient(
    circle at 90% 100%,
    var(--color-purple-1),
    var(--color-purple-0) 90%
  );
  --gradient-yellow-1: radial-gradient(
    circle at 90% 100%,
    var(--color-yellow-2),
    var(--color-yellow-1) 100%
  );
  --gradient-red-1: radial-gradient(circle at 10% 0%, var(--color-red-2), var(--color-red-1) 100%);
}

.rescueally {
  --shadow-0: 0.125em 0.125em 1em rgba(0, 0, 0, 0.1);
  --shadow-1: 0.125em 0.125em 0.6em rgba(0, 0, 0, 0.09);
  --shadow-2: 0.25em 0.25em 1em 0em rgba(0, 0, 0, 0.1);
}

@media (prefers-color-scheme: dark) {

:not(.rescueally-light).rescueally {
    --shadow-0: none;
    --shadow-1: 0.125em 0.125em 0.6em rgba(0, 0, 0, 0.15);
    --shadow-2: 0.25em 0.25em 1em 0.3em rgba(0, 0, 0, 0.2);
}
  }

.rescueally-dark.rescueally {
    --shadow-0: none;
    --shadow-1: 0.125em 0.125em 0.6em rgba(0, 0, 0, 0.15);
    --shadow-2: 0.25em 0.25em 1em 0.3em rgba(0, 0, 0, 0.2);
}

.rescueally {
  --default-transition-duration: 400ms;
  --default-transition-timing: ease;
}

.rescueally {
  --default-focus-outline-color: var(--color-blue-1);
  --default-focus-outline-style: solid;
  --default-focus-outline-width: 2px;
  --default-focus-outline: var(--default-focus-outline-color) var(--default-focus-outline-style)
    var(--default-focus-outline-width);
}
`, "",{"version":3,"sources":["webpack://./src/theme/variables.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;EAC7B;AACF;;AAPE;IACE,oCAAoC;IACpC,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;EAC7B;;AAGF;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;;EAEvB;;;;GAIC;EACD;;;;GAIC;EACD;;;;GAIC;EACD,gGAAgG;AAClG;;AAEA;EACE,kDAAkD;EAClD,qDAAqD;EACrD,oDAAoD;AAMtD;;AALE;;AAJF;IAKI,gBAAgB;IAChB,qDAAqD;IACrD,sDAAsD;AAE1D;EADE;;AARF;IAKI,gBAAgB;IAChB,qDAAqD;IACrD,sDAAsD;AAE1D;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,kCAAkC;EAClC;sCACoC;AACtC","sourcesContent":[".rescueally {\n  /* light */\n  --color-grey-0: #f8f8ff;\n  --color-grey-1: #f3f3fc;\n  --color-grey-2: #f1f1fc;\n  --color-grey-3: #eaeafa;\n  /* dark */\n  --color-grey-4: #333333;\n  --color-grey-5: #2f2f2f;\n  --color-grey-6: #222222;\n  --color-grey-7: #171717;\n  --color-grey-8: #111111;\n}\n\n.rescueally {\n  --color-paper-1: var(--color-grey-3);\n  --color-paper-2: white;\n  --color-inverse: black;\n  --color-paper-text: black;\n  --color-inverse-text: white;\n}\n\n@media (prefers-color-scheme: dark) {\n  .rescueally {\n    --color-paper-1: var(--color-grey-5);\n    --color-paper-2: var(--color-grey-6);\n    --color-inverse: var(--color-grey-0);\n    --color-paper-text: white;\n    --color-inverse-text: black;\n  }\n}\n\n.rescueally {\n  --color-blue-0: #48dbfb;\n  --color-blue-1: #0984e3;\n  --color-blue-2: #1e3799;\n  --color-blue-3: #023047;\n  --color-blue-4: #011a24;\n  --color-red-0: #ff0000;\n  --color-red-1: #ee3031;\n  --color-red-2: #b33939;\n  --color-red-3: #a20025;\n  --color-yellow-1: #fbc531;\n  --color-yellow-2: #f6b93b;\n  --color-green-1: #27ae60;\n  --color-green-2: #364541;\n  --color-purple-0: #a55eea;\n  --color-purple-1: #8e44ad;\n  --color-purple-2: #5f27cd;\n  --color-pink-1: #ff9ff3;\n\n  --gradient-blue-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-blue-1),\n    var(--color-blue-0) 250%\n  );\n  --gradient-purple-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-purple-1),\n    var(--color-purple-0) 90%\n  );\n  --gradient-yellow-1: radial-gradient(\n    circle at 90% 100%,\n    var(--color-yellow-2),\n    var(--color-yellow-1) 100%\n  );\n  --gradient-red-1: radial-gradient(circle at 10% 0%, var(--color-red-2), var(--color-red-1) 100%);\n}\n\n.rescueally {\n  --shadow-0: 0.125em 0.125em 1em rgba(0, 0, 0, 0.1);\n  --shadow-1: 0.125em 0.125em 0.6em rgba(0, 0, 0, 0.09);\n  --shadow-2: 0.25em 0.25em 1em 0em rgba(0, 0, 0, 0.1);\n  @media (prefers-color-scheme: dark) {\n    --shadow-0: none;\n    --shadow-1: 0.125em 0.125em 0.6em rgba(0, 0, 0, 0.15);\n    --shadow-2: 0.25em 0.25em 1em 0.3em rgba(0, 0, 0, 0.2);\n  }\n}\n\n.rescueally {\n  --default-transition-duration: 400ms;\n  --default-transition-timing: ease;\n}\n\n.rescueally {\n  --default-focus-outline-color: var(--color-blue-1);\n  --default-focus-outline-style: solid;\n  --default-focus-outline-width: 2px;\n  --default-focus-outline: var(--default-focus-outline-color) var(--default-focus-outline-style)\n    var(--default-focus-outline-width);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
